import { YStack, XStack, Text, useMedia } from 'tamagui'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faTv } from '@fortawesome/free-solid-svg-icons/faTv'
import { faMobileScreenButton } from '@fortawesome/free-solid-svg-icons/faMobileScreenButton'
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap'
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
import { IProductPage } from '@dtos/ProductPage'
import { CONTAINER_WIDTH } from './constants'
import { useResolvedColors } from './hooks'

// Faixa de features (productPage_features): ícones na cor de destaque,
// em pares no mobile.
export function FeaturesRow({ product }: { product: IProductPage }) {
  const { t } = useTranslation('ProductPage')
  const media = useMedia()
  const colors = useResolvedColors()
  const isLiveMeet = product.course?.kind === 'live_meet'

  const items: { icon: IconDefinition; label: string }[] = []
  if (product.availableTimeType === 'indeterminate') {
    items.push({
      icon: faTv,
      label: isLiveMeet
        ? t('features.indeterminate-live-meet')
        : t('features.indeterminate'),
    })
  }
  items.push({ icon: faMobileScreenButton, label: t('features.app') })
  if (product.certification) {
    items.push({ icon: faGraduationCap, label: t('features.certification') })
  }
  items.push({ icon: faUser, label: t('features.accessibility') })

  return (
    <XStack
      width="100%"
      maxWidth={CONTAINER_WIDTH}
      paddingHorizontal={16}
      marginTop={64}
      justifyContent="space-between"
      flexWrap="wrap"
      gap={32}
    >
      {items.map((item) => (
        <YStack
          key={item.label}
          alignItems="center"
          maxWidth={media.gtSm ? 160 : undefined}
          flexBasis={media.gtSm ? undefined : '40%'}
          gap={8}
          flexGrow={1}
        >
          <FontAwesomeIcon icon={item.icon} size={26} color={colors.accent} />
          <Text
            color="$text-primary"
            fontSize={16}
            lineHeight={24}
            fontFamily="$mulishSemiBold"
            fontWeight="600"
            textAlign="center"
          >
            {item.label}
          </Text>
        </YStack>
      ))}
    </XStack>
  )
}
